export default "https://assets.pclncdn.com/web/next-landing/b9d3836/_next/static/images/atlanta-84fa7ae4bb1f7547470d71226164076b.webp";